<template>
    <Dialog v-model:visible="visible" :header="$t('general.confirm')" class="w-96" modal @hide="answer(false)">
        <p class="dark:text-slate-200">{{ message }}</p>
        <div class="flex justify-end gap-2 mt-5">
            <Button :label="$t('general.cancel')" severity="secondary" @click="answer(false)" />
            <Button :label="$t('general.confirm')" @click="answer(true)" />
        </div>
    </Dialog>
</template>

<script lang="ts" setup>
    import { Button, Dialog } from 'primevue'
    import { onBeforeUnmount, ref } from 'vue'

    const visible = ref(false)
    const message = ref('')

    let resolver: ((value: boolean) => void) | undefined

    const confirm = (text: string): Promise<boolean> => {
        message.value = text
        visible.value = true
        return new Promise(resolve => { resolver = resolve })
    }

    // Every way out of the dialog MUST settle the promise. Only the two buttons
    // used to call answer(), so closing with Esc or the header X left the caller
    // awaiting forever — with the action half-started (a `saving` flag set, a
    // spinner spinning) and no way back except a reload. @hide covers Esc/X (it
    // fires after the buttons' own answer(), where the resolver is already gone,
    // so a decision is never overwritten), and unmounting the host view cancels.
    const answer = (value: boolean) => {
        visible.value = false
        resolver?.(value)
        resolver = undefined
    }

    onBeforeUnmount(() => answer(false))

    defineExpose({ confirm })
</script>
